<style>
  #footer-inner {
    margin-top: 180px;
  }
</style>

<template lang="pug" src="./footer.pug"></template>
